import React, { FC } from 'react';
import { cn, useComponentTheme } from '@/utils';
import { DividerTheme } from './DividerTheme';

export interface DividerProps {
  /**
   * Classname to apply to the divider.
   */
  className?: string;

  /**
   * Disable the margins of the divider.
   * The default margin is: `--spacings-md`.
   * @default false
   */
  disableMargins?: boolean;

  /**
   * Orientation of the divider.
   * @default 'horizontal'
   */
  orientation?: 'horizontal' | 'vertical';

  /**
   * Additional style attributes. Recommend to use css classes over this.
   */
  style?: React.CSSProperties;

  /**
   * Theme for the Divider.
   */
  theme?: DividerTheme;

  /**
   * Variant of the divider.
   * @default 'primary'
   */
  variant?: 'primary' | 'secondary';
}

export const Divider: FC<DividerProps> = ({
  className,
  disableMargins = false,
  orientation = 'horizontal',
  variant = 'primary',
  theme: customTheme,
  ...rest
}) => {
  const theme: DividerTheme = useComponentTheme('divider', customTheme);

  return (
    <hr
      {...rest}
      className={cn(
        theme.base,
        theme.variant[variant],
        theme.orientation[orientation],
        disableMargins && theme.disableMargins,
        className
      )}
    />
  );
};
